module.exports = __webpack_public_path__ + "8ac0fc3ce0c115c892b7702e75ba1509.pdf";